var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-table',{attrs:{"url":"/api/v1/giftCategory","attributes":[
    {
      attribute: 'name',
      name: 'Name'
    },
    {
      attribute: 'active',
      name: 'Aktiv',
      type: 'CheckMarkerCell'
    },
    {
      attribute: 'update_page_url',
      name: 'Bearbeiten',
      type: 'ActionCell',
      label: 'Bearbeiten',
      sortable: false
    },
    {
      attribute: 'update_url',
      name: 'Löschen',
      type: 'DeleteCell',
      label: 'Löschen',
      text: 'Sicher? Alle Geschenke in dieser Kategorie werden gelöscht',
      sortable: false
    }
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }